import { render, staticRenderFns } from "./data82.vue?vue&type=template&id=67be184a&scoped=true"
import script from "./data82.vue?vue&type=script&lang=js"
export * from "./data82.vue?vue&type=script&lang=js"
import style1 from "./data82.vue?vue&type=style&index=1&id=67be184a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be184a",
  null
  
)

export default component.exports